import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import {
  CardElements,
  CardsCommonElements,
  Classes,
  Colors,
  CustomElement,
  GeneralCardSubElements,
} from "@/types";
import {
  canCardArrayVModel,
  canVModel,
  getBreakpoint,
  getBreakpointClasses,
} from "@/utils";
import { IonItemDivider, IonItem } from "@ionic/vue";
import {
  PropType,
  WatchStopHandle,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GroupList',
  props: {
  emptiness_message: {
    type: Object as PropType<CustomElement>,
    required: true,
  },
  divider: {
    type: Object as PropType<CustomElement>,
    required: true,
  },
  cards_list: {
    type: Array<CardElements>,
    required: true,
  },
  colors: Object as PropType<Colors<GeneralCardSubElements>>,
  classes: Object as PropType<Classes<CardsCommonElements>>,
},
  emits: [
  "execute_link",
  "signal_event",
  "update:emptiness_message",
  "update:divider",
  "update:cards_list",
],
  setup(__props, { emit }) {

const props = __props;

const addListeners = () => {
  watch(
    () => props.cards_list,
    (value) => {
      cards_list_ref.value = value;
    }
  );
  watch(
    () => cards_list_ref.value,
    (value) => {
      emit("update:cards_list", value);
    }
  );
};
const updateBreakpoint = () => {
  breakpoint.value = getBreakpoint(window.innerWidth);
};




const emptiness_message_ref = ref(props.emptiness_message);
const divider_ref = ref(props.divider);
const cards_list_ref = ref(props.cards_list);
const breakpoint = ref(getBreakpoint(window.innerWidth));

let stopWatch: WatchStopHandle;

if (
  props.emptiness_message != undefined &&
  canVModel(props.emptiness_message)
) {
  watch(
    () => props.emptiness_message,
    (value) => {
      emptiness_message_ref.value = value;
    }
  );
  watch(
    () => emptiness_message_ref.value,
    (value) => {
      emit("update:emptiness_message", value);
    }
  );
}
if (props.divider != undefined && canVModel(props.divider)) {
  watch(
    () => props.divider,
    (value) => {
      divider_ref.value = value;
    }
  );
  watch(
    () => divider_ref.value,
    (value) => {
      emit("update:divider", value);
    }
  );
}
if (props.cards_list.length == 0) {
  stopWatch = watch(
    () => props.cards_list,
    (value) => {
      cards_list_ref.value = value;
      if (value.length > 0 && canCardArrayVModel(props.cards_list)) {
        addListeners();
        stopWatch();
      }
    }
  );
} else if (canCardArrayVModel(props.cards_list)) {
  addListeners();
}

if (props.classes?.divider != undefined) {
  onMounted(() =>
    nextTick(() => {
      window.addEventListener("resize", updateBreakpoint);
    })
  );

  onBeforeUnmount(() => {
    window.removeEventListener("resize", updateBreakpoint);
  });
}

return (_ctx: any,_cache: any) => {
  const _component_ionic_element = _resolveComponent("ionic-element")!
  const _component_card_item = _resolveComponent("card-item")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonItemDivider), {
      color: 
      (__props.colors?.dividers?.type == 'var' ? __props.colors?.dividers.name : undefined) ??
      'light'
    ,
      class: _normalizeClass({
      ..._unref(getBreakpointClasses)(__props.classes?.divider, breakpoint.value),
      background:
        __props.colors?.dividers != undefined && __props.colors.dividers.type != 'var',
    })
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ionic_element, {
          element: divider_ref.value,
          "onUpdate:element": _cache[0] || (_cache[0] = ($event: any) => ((divider_ref).value = $event))
        }, null, 8, ["element"])
      ]),
      _: 1
    }, 8, ["color", "class"]),
    (__props.cards_list.length === 0)
      ? (_openBlock(), _createBlock(_unref(IonItem), {
          key: 0,
          color: 
      __props.colors?.background?.type == 'var' ? __props.colors?.background.name : undefined
    ,
          class: _normalizeClass([{
      background:
        __props.colors?.background != undefined && __props.colors?.background?.type != 'var',
    }, "ion-no-padding"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ionic_element, {
              element: emptiness_message_ref.value,
              "onUpdate:element": _cache[1] || (_cache[1] = ($event: any) => ((emptiness_message_ref).value = $event))
            }, null, 8, ["element"])
          ]),
          _: 1
        }, 8, ["color", "class"]))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(cards_list_ref.value, (card, i) => {
          return (_openBlock(), _createBlock(_component_card_item, {
            key: card.id,
            card: cards_list_ref.value[i],
            colors: __props.colors,
            classes: __props.classes,
            onExecute_link: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('execute_link'))),
            onSignal_event: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('signal_event')))
          }, null, 8, ["card", "colors", "classes"]))
        }), 128))
  ], 64))
}
}

})